import { map } from 'rxjs';
import { inject } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { CanActivateFn, Router } from '@angular/router';
import { selectQueryParams } from '@chiron/app/state/router.selectors';
import { AuthenticationService } from '../services/authentication.service';

export const canResetPasswordGuard: CanActivateFn = () => {
  const store = inject(Store);
  const router = inject(Router);
  const authService = inject(AuthenticationService);
  return store.pipe(
    select(selectQueryParams),
    map(({ jwt }) => {
      if (!jwt || !authService.isTokenValid(jwt)) {
        router.navigate(['/reset-link-expired']);
        return false;
      }
      return true;
    })
  );
};
